import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environmentManuales } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ManualesyPoliticasService {
    constructor(private http: HttpClient) { }

    getByFilter(manualID,groupID) {
        let body ={
            policeProcedureID : manualID,
            PoliceProcedureDocumentID: 0,
            PoliceProcedureDocumentParentID: 0,
            PoliceProcedureDocumentCode: "",
            PoliceProcedureDocumentName: "",
            DocumentIdiomID: 0,
            DocumentAttachmentID: 0,
            DocumentGroupCode : groupID
        }
        return this.http.get<any>(`${environmentManuales.apiUrl}/PoliceProcedureDocument/GetByFilter2?documentGroupCode=${groupID}&policeProcedureID=${manualID}`);
  }

    getAllGroup1() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
          });
      
          // Agrega los encabezados a la solicitud HTTP
          //const opciones = { headers: headers };
        return this.http.get<any>(`${environmentManuales.apiUrl}/PoliceProcedure/GetGroup?code=01`);
    }
    

    getAllGroup2() {
        return this.http.get<any>(`${environmentManuales.apiUrl}/PoliceProcedure/GetGroup?code=02`);
    }

    getAllGroup3() {
        return this.http.get<any>(`${environmentManuales.apiUrl}/PoliceProcedure/GetGroup?code=03`);
    }

}
